import cls from 'classnames';
import Tag from 'icon/tag.svg';
import TagFill from 'icon/tag_fill.svg';
import { useScopedAtom, useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { FC, useCallback } from 'react';
import { $LabelVisible, $LabelSwitcherVisible } from '../../atoms';
import { ClickPosition } from '~/utils/click-position';
import { useViewObserver } from '@lemon8/web-app-shared/util';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';
import { $AdditionalParams } from '~/models/additional-params';

import './style.scss';

export const LabelVisibleSwitcher: FC = () => {
  const labelSwitcherVisible = useScopedAtomValue($LabelSwitcherVisible);
  const [labelVisible, setLabelVisible] = useScopedAtom($LabelVisible);
  const prefix = useScopedAtomValue($CurrentPositionPrefix);
  const additionalParams = useScopedAtomValue($AdditionalParams);

  const observedRef = useViewObserver({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_position: prefix + ClickPosition.main_gallery_label_switcher,
        is_cta: 0,
        ...additionalParams,
      });
    }, []),
  });

  const handleLabelSwitcherClick = useCallback(() => {
    setLabelVisible(!labelVisible);
    window.Tea('wap_click', {
      current_position: prefix + ClickPosition.main_gallery_label_switcher,
      is_cta: 0,
      ...additionalParams,
    });
  }, [labelVisible]);

  return (
    <div
      ref={observedRef}
      className={cls('label-visible-switcher', {
        label_shown: labelVisible,
        shown: labelSwitcherVisible,
      })}
      onClick={handleLabelSwitcherClick}
    >
      {labelVisible ? <Tag /> : <TagFill />}
    </div>
  );
};
